<template>
  <b-modal :id="'archive-confirm-' + appId" hide-header centered>
    <div class="confirm-text">
      {{ confirmDeleteText }}
    </div>
    <template v-slot:modal-footer>
      <button class="model-btn modal-cancel-btn" @click="closeModal()">
        {{ cancelText }}
      </button>
      <button class="model-btn modal-save-btn" @click="doArchive()">
        {{ okText }}
      </button>
    </template>
  </b-modal>
</template>

<script>
  import { mapState } from "vuex";
  import services from "@/services";

  export default {
    name: "ArchiveConfirm",
    computed: {
      ...mapState({
        messages: "messages"
      }),
      confirmDeleteText() {
        return this.getMessageText(this.messages.CONFIRM_DELETE);
      },
      cancelText() {
        return this.getMessageText(this.messages.CANCEL);
      },
      okText() {
        return this.getMessageText(this.messages.OK);
      }
    },
    props: {
      appId: String
    },
    methods: {
      closeModal() {
        this.$bvModal.hide("archive-confirm-" + this.appId);
      },
      doArchive() {
        let component = this;
        services.archiveApp(component.appId).then(() => {
          component.$router.go();
        }, console.error);
        this.$bvModal.hide("archive-confirm-" + this.appId);
      }
    }
  };
</script>

<style scoped>
  .confirm-text {
    text-align: center;
  }

  .model-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: #0070d2;
    -webkit-appearance: none;
    white-space: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
  }

  .modal-save-btn {
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    background-color: #0070d2;
    border: 1px solid #0070d2;
    color: #fff;
  }

  .modal-cancel-btn {
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    border: 1px solid #dddbda;
    background-color: #fff;
  }
</style>
